<template>
  <div class="h-screen flex w-full vx-row no-gutter items-center justify-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/3 xl:w-1/3 sm:m-0 m-4">
      <vx-card ref="autenticador">
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter">
            <div class="vx-col sm:w-full md:w-full mx-auto self-center d-theme-dark-bg">
              <div class="pt-0 pr-5 pl-5">
                <template v-if="concluido">
                  <h2>Foto verificada :)</h2>
                  <p>Sua foto foi aprovada com sucesso.</p>
                </template>
                <template v-else>
                  <form-wizard
                    color="rgba(var(--vs-primary), 1)"
                    title="Autenticação de dados"
                    subtitle="Siga as etapas e valide seu registro"
                    finishButtonText="Concluir"
                    nextButtonText="Avançar"
                    backButtonText="Voltar"
                    @on-complete="formSubmitted"
                  >
                    <tab-content class="mb-5" icon="feather icon-home">
                      <vs-divider />
                      <div class="vx-row">
                        <div class="vx-col md:w-1/2 w-full mt-5 text-center">
                          <div class="vx-card__title mb-8">
                            <h4 class="mb-4">Vamos tirar uma selfie?</h4>
                            <p>Tenha em mãos seu documento.</p>
                          </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                          <img
                            src="../../../assets/images/pages/selfie-example.jpg"
                            width="100%"
                            style="border-radius: 20px;"
                          />
                        </div>
                      </div>
                      <vs-divider />
                    </tab-content>

                    <tab-content class="mb-5" icon="feather icon-file-text">
                      <vs-divider />
                      <div class="vx-card__title text-center">
                        <h4>Siga as instruções</h4>
                      </div>
                      <vs-divider />

                      <div class="vx-row">
                        <div class="vx-col md:w-1/2 w-full mb-3">
                          <!-- <vs-list>
                          <vs-list-header
                            icon-pack="feather"
                            icon="icon-camera"
                            title="Foto segurando seu documento"
                            color="primary"
                          ></vs-list-header>
                          </vs-list>-->
                          <vs-list>
                            <vs-list-header
                              icon-pack="feather"
                              icon="icon-list"
                              title="Não pode"
                              color="danger"
                            ></vs-list-header>
                            <vs-list-item
                              icon-pack="feather"
                              icon="icon-x"
                              title="Usar óculos de grau/escuro"
                            ></vs-list-item>
                            <vs-list-item
                              icon-pack="feather"
                              icon="icon-x"
                              title="Sorrir ou com a boca aberta"
                            ></vs-list-item>
                            <vs-list-item
                              icon-pack="feather"
                              icon="icon-x"
                              title="Usar boné ou chapéu"
                            ></vs-list-item>
                          </vs-list>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                          <vs-list>
                            <vs-list-header
                              icon-pack="feather"
                              icon="icon-list"
                              title="Recomendado"
                              color="success"
                            ></vs-list-header>
                            <vs-list-item
                              icon-pack="feather"
                              icon="icon-check"
                              title="Tenha seu documento em mãos"
                            ></vs-list-item>
                            <vs-list-item
                              icon-pack="feather"
                              icon="icon-check"
                              title="Ambiente claro e iluminado"
                            ></vs-list-item>
                          </vs-list>
                        </div>
                      </div>
                      <vs-divider />
                    </tab-content>

                    <tab-content class="mb-5 mt-5" icon="feather icon-camera">
                      <div class="vx-row">
                        <div class="vx-col md:w-1/2 w-full mt-5 mb-3 text-center">
                          <div class="vx-card__title">
                            <h4>
                              Tire uma
                              <i>foto</i> segurando seu
                              <br />
                              <b>documento com foto</b>.
                            </h4>
                          </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                          <template v-if="mostrarUpload">
                            <file-pond
                              name="arquivo"
                              ref="pond"
                              label-idle="Clique aqui para abrir a câmera"
                              v-bind:allow-multiple="false"
                              accepted-file-types="image/jpeg, image/png"
                            />
                          </template>
                        </div>
                      </div>
                    </tab-content>
                  </form-wizard>
                </template>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import api from "@services/api-service";

// Import Vue FilePond
import vueFilePond, { setOptions } from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

export default {
  data() {
    return {
      loading: false,
      concluido: false,
      mostrarUpload: true,
      uploadAction: process.env.VUE_APP_API_URL + "/enviar-documento-externo",
      uploadData: {
        subtipo: "CNH",
        contrato_anexo_tipo_id: 2,
        contrato_id: null
      }
    };
  },
  mounted() {
    let codigo = this.$route.params.codigo;

    this.loading = true;

    api()
      .post(`/contratos/verificar-codigo`, { codigo })
      .then(response => {
        if (!response.data.status) {
          return this.$router.push({ name: "error-404" });
        }

        this.uploadData.contrato_id = response.data.data.id;
        this.loading = false;
      })
      .catch(error => this.$router.push({ name: "error-404" }));
  },
  watch: {
    uploadData: {
      handler(uploadData) {
        setOptions({
          server: {
            url: this.uploadAction,
            process: {
              method: "POST",
              onload: response => this.onSuccess(JSON.parse(response)),
              onerror: () => this.onError(),
              ondata: formData => {
                formData.append(
                  "contrato_anexo_tipo_id",
                  uploadData.contrato_anexo_tipo_id
                );
                formData.append("subtipo", uploadData.subtipo);
                formData.append("contrato_id", uploadData.contrato_id);
                return formData;
              }
            }
          }
        });
      },
      deep: true
    },
    loading(loading) {
      if (loading) {
        this.$refs.autenticador.refreshcard();
      } else {
        this.$refs.autenticador.removeRefreshAnimation();
      }
    }
  },
  methods: {
    formSubmitted() {
      // this.concluido = true;
    },
    onSuccess(response) {
      console.log(response);
      this.loading = false;
      setTimeout(() => {
        if (!response.status) {
          this.mostrarUpload = false;
          setTimeout(() => (this.mostrarUpload = true), 200);
          this.$vs.notify({
            color: "danger",
            title: "Ops! :(",
            text:
              "Não foi possível enviar o documento, tente novamente mais tarde.",
            iconPack: "feather",
            icon: "icon-check",
            position: "top-right"
          });
        }

        if (response.data.valido) {
          this.concluido = true;
        } else {
          this.mostrarUpload = false;
          setTimeout(() => (this.mostrarUpload = true), 200);
          let [error] = response.data.erros;
          return this.$vs.notify({
            color: "danger",
            title: "Ops! :(",
            text: error,
            iconPack: "feather",
            icon: "icon-check",
            position: "top-right"
          });
        }
      }, 200);
    },
    onError() {
      this.loading = false;
      this.mostrarUpload = false;
      setTimeout(() => (this.mostrarUpload = true), 200);
      this.$vs.notify({
        color: "danger",
        title: "Ops! :(",
        text:
          "Não foi possível enviar o documento, tente novamente mais tarde.",
        iconPack: "feather",
        icon: "icon-check",
        position: "top-right"
      });
    }
  },
  components: {
    FormWizard,
    TabContent,
    FilePond
  }
};
</script>

<style>
/*
 * FilePond Custom Styles
 */

.filepond--drop-label {
  color: #4c4e53;
  min-height: 200px !important;
}

.filepond--root {
  min-height: 200px !important;
}

.filepond--label-action {
  text-decoration-color: #babdc0;
}

.filepond--panel-root {
  background-color: #edf0f4;
}
</style>
